/**
 * @generated SignedSource<<1828d7e4087f874b0bd2d575f1444e4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleMoreOnThisListStyleArticle$data = {
  readonly styleMoreOnThisArticles: ReadonlyArray<{
    readonly entityId: string;
    readonly urlAlias: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "magazinesStyleArticleMoreOnThisContentItemContent">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "articleMoreOnThisListStyleArticle";
};
export type articleMoreOnThisListStyleArticle$key = {
  readonly " $data"?: articleMoreOnThisListStyleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleMoreOnThisListStyleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleMoreOnThisListStyleArticle",
  "selections": [
    {
      "alias": "styleMoreOnThisArticles",
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "magazinesStyleArticleMoreOnThisContentItemContent"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlAlias",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "3dee43ce9a01d5258bed127e3b08eeaa";

export default node;
